/**
 * Sticky date-range sidebar shown to the left of the portfolio list.
 *
 * As you scroll, the date whose project is currently "in view" stays at its
 * default size (the CSS already sets `scale(1.4)` for `.date-range .date`).
 * Dates one step away shrink to scale 1.2 (`.next1` / `.prev1`), two away to
 * scale 1.05 (`.next2` / `.prev2`), and anything further fades out via the
 * `.ps-hide` class. The smooth interpolation is pure CSS — we just toggle
 * classes based on the active index reported by the scroll hook.
 */
interface Props {
  dates: string[];
  activeIndex: number;
  onSelect: (index: number) => void;
}

function classForOffset(offset: number): string {
  // offset = i - activeIndex
  if (offset === 0) return ''; // base (active) state — largest
  if (offset === -1) return 'prev1';
  if (offset === 1) return 'next1';
  if (offset === -2) return 'prev2';
  if (offset === 2) return 'next2';
  return 'ps-hide';
}

export default function DateSidebar({ dates, activeIndex, onSelect }: Props) {
  if (dates.length === 0) return null;
  return (
    <div className="date-range text-right">
      {dates.map((date, i) => {
        const cls = `date ${classForOffset(i - activeIndex)}`.trim();
        return (
          <a
            key={`${date}-${i}`}
            className={cls}
            onClick={(e) => {
              e.preventDefault();
              onSelect(i);
            }}
            href="#"
          >
            {date}
          </a>
        );
      })}
    </div>
  );
}
